export default __webpack_public_path__ + "static/media/13n.c1df9c10.svg";